import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface FAQ {
  question: string;
  answer: string;
}
export function FAQAccordion({
  faqs
}: {
  faqs: FAQ[];
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto space-y-4" data-id="element-10">
      {faqs.map((faq, index) => <div key={index} className="border border-white/10 rounded-lg overflow-hidden bg-slate-900/50 backdrop-blur-sm transition-colors hover:bg-slate-900" data-id="element-11">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-12">
            <span className="font-semibold text-lg text-white pr-4 flex items-start gap-3" data-id="element-13">
              <span className="text-amber-500" data-id="element-14">❓</span>
              {faq.question}
            </span>
            <ChevronDown className={`w-5 h-5 text-amber-500 transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-15" />
          </button>
          <AnimatePresence data-id="element-16">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} data-id="element-17">
                <div className="px-6 pb-6 pt-2 text-slate-300 leading-relaxed flex items-start gap-3" data-id="element-18">
                  <span className="text-green-500 mt-1" data-id="element-19">✅</span>
                  <div data-id="element-20">{faq.answer}</div>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}